import t from "@/lang/lang";
import { EditLabCard } from "@/services/backend/samples/components/edit-lab-card";
import { DeleteLabDialog } from "@/services/backend/samples/components/delete-lab-dialog";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Button } from "@/shared/components/ui/button";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { ArrowLeft } from "lucide-react";
import { NavLink, useNavigate, useParams } from "react-router";
import { useSamplesLaboratoryShowQuery } from "@/services/backend/samples/api/lab-api";

export function LabRoute() {
  const { labId } = useParams();
  const navigate = useNavigate();
  const {
    data: lab,
    isLoading,
    error,
  } = useSamplesLaboratoryShowQuery({ id: labId! });

  return (
    <div className="grid gap-2">
      <div className="flex items-center justify-between">
        <NavLink to="../">
          <Button variant="outline">
            <ArrowLeft />
            <span>{t("Zurück zur Übersicht")}</span>
          </Button>
        </NavLink>
        <div className="flex items-center gap-4">
          <PersistenceStateUsingContext />
          {lab && (
            <DeleteLabDialog lab={lab} onDelete={() => navigate("../")} />
          )}
        </div>
      </div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {lab && <EditLabCard lab={lab} key={lab.id} />}
    </div>
  );
}
